import React, { FC } from "react";

import { FourthStepInfoContainer } from "../FormElements";

import { interpolate } from "../Helpers";
import { useLabels } from "../Hooks/useLabels";

import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { CreateBookingResponseDto } from "../../../../Api/Model/CreateBookingResponseDto.csharp";
import {RichTextArea} from "../RichTextArea/RichTextArea";
import {SvgIcon} from "../../SvgIcon/SvgIcon";

type PracticalInformationProps = {
  bookingResponse: CreateBookingResponseDto;
  service: ServiceContainerDto;
  specializationName: string;
  isWaitlist: boolean;
  hideGeneralInfo?: boolean;
};

export const PracticalInformation: FC<PracticalInformationProps> = ({
  bookingResponse,
  service,
  specializationName,
  isWaitlist,
  hideGeneralInfo,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const displayVideoLink =
    bookingResponse.videoLink &&
    bookingResponse.videoLink.url &&
    bookingResponse.videoLink.title;

  const link = fourthStepLabels!.serviceLink.replace(
    "$service",
    !!service.serviceUrl 
        ? service.name 
        : specializationName
  );

  const shouldShow =
    (displayVideoLink && !!bookingResponse.videoDescription) ||
    !!bookingResponse.practicalInformationDoctor ||
    !!bookingResponse.practicalInformation ||
    (!isWaitlist && !hideGeneralInfo && !!fourthStepLabels?.generalInfo);

  if (!shouldShow) {
    return null;
  }
  return (
    <FourthStepInfoContainer title={fourthStepLabels?.practicalInformationHeading ?? "Nødvendig informasjon"}>
      <div className="PracticalInformation">
        {displayVideoLink && (
            <RichTextArea
             content={interpolate(
                bookingResponse.videoDescription,
                "$videoLink", 
                `<a href="${bookingResponse.videoLink.url}">
                  ${bookingResponse.videoLink.title}
                </a>`
              )
            }
          />
        )}
        {bookingResponse.practicalInformationDoctor && (
            <RichTextArea content={bookingResponse.practicalInformationDoctor} />
        )}
        {bookingResponse.practicalInformation && (
            <RichTextArea content={bookingResponse.practicalInformation} />
        )}
        {!isWaitlist && !hideGeneralInfo && (
          <>
            <RichTextArea content={fourthStepLabels?.generalInfo ?? ""} />
            
            <a href={service.serviceUrl || service.specializationUrl} className="PracticalInformation__link">
              <span className="">{link}</span>
              <SvgIcon iconName="arrow-right"/>
            </a>
          </>
        )}
      </div>
    </FourthStepInfoContainer>
  );
};
